'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _TabPanel = require('./TabPanel.css');

var _TabPanel2 = _interopRequireDefault(_TabPanel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * This component is shown when a tab is selected
 */
var TabPanel = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(TabPanel, _Component);

  function TabPanel() {
    (0, _classCallCheck3.default)(this, TabPanel);
    return (0, _possibleConstructorReturn3.default)(this, (TabPanel.__proto__ || (0, _getPrototypeOf2.default)(TabPanel)).apply(this, arguments));
  }

  (0, _createClass3.default)(TabPanel, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          className = _props.className;

      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(className, _TabPanel2.default.root) },
        children
      );
    }
  }]);
  return TabPanel;
}(_react.Component), _class.propTypes = {
  className: _react.PropTypes.string,
  children: _react.PropTypes.node
}, _temp);
exports.default = TabPanel;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/enterprise/EnterpriseTabs/TabPanel/TabPanel.jsx
// module id = 1617
// module chunks = 0